import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "./api";
import { useNavigate, useParams } from "react-router-dom";

function EditDeal() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    buyer: "",
    bales: "",
    sauda: "",
    candyrate: "",
    quality: "",
    dealperiods: "",
    terms: "",
    remarks: "",
    seller: "",
    station: "",
    date: "",
    dalali: "",
  });

  // 🔹 Fetch deal by ID
  useEffect(() => {
    api.get(`/getDeal/${id}`).then((res) => {
      setFormData({
        buyer: res.data.buyer,
        bales: res.data.bales,
        sauda: res.data.sauda,
        candyrate: res.data.candy_rate,
        quality: res.data.quality,
        dealperiods: res.data.deal_period,
        terms: res.data.terms,
        remarks: res.data.remarks,
        seller: res.data.seller,
        station: res.data.station,
        date: res.data.date?.slice(0, 10),
        dalali: res.data.dalali,
      });
    });
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 🔹 Update deal
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/updateDeal/${id}`, formData);
      alert("✅ Deal updated successfully");
      navigate("/my-deals");
    } catch (err) {
      console.error(err);
      alert("❌ Failed to update deal");
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-lg border-0 rounded-4">
        <div className="card-header bg-warning text-dark text-center rounded-top-4">
          <h3 className="mb-0">✏️ Edit Deal</h3>
        </div>

        <div className="card-body p-4">
          <form onSubmit={handleSubmit} className="row g-4">

            {/* Buyer */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Buyer</label>
              <input
                type="text"
                className="form-control"
                name="buyer"
                value={formData.buyer}
                onChange={handleChange}
                required
              />
            </div>

            {/* Seller */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Seller</label>
              <input
                type="text"
                className="form-control"
                name="seller"
                value={formData.seller}
                onChange={handleChange}
                required
              />
            </div>

            {/* Bales */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Bales</label>
              <input
                type="number"
                className="form-control"
                name="bales"
                value={formData.bales}
                onChange={handleChange}
                required
              />
            </div>

            {/* Station */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Station</label>
              <input
                type="text"
                className="form-control"
                name="station"
                value={formData.station}
                onChange={handleChange}
                required
              />
            </div>

             {/* Sauda */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📑 Sauda</label>
              <textarea
                className="form-control rounded-3 shadow-sm"
                name="sauda"
                rows="3"
                value={formData.sauda}
                onChange={handleChange}
                placeholder="Enter sauda details"
                required
              ></textarea>
            </div>

            {/* Candy Rate */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Candy Rate</label>
              <input
                type="text"
                className="form-control"
                name="candyrate"
                value={formData.candyrate}
                onChange={handleChange}
                required
              />
            </div>

            {/* Dalali */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Dalali</label>
              <input
                type="number"
                className="form-control"
                name="dalali"
                value={formData.dalali}
                onChange={handleChange}
                required
              />
            </div>
             {/* Quality */}
            <div className="col-md-6">
              <label className="form-label fw-bold">⭐ Quality</label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="quality"
                value={formData.quality}
                onChange={handleChange}
                placeholder="Enter quality"
                required
              />
            </div>

            {/* Deal Periods */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📆 Deal Periods</label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="dealperiods"
                value={formData.dealperiods}
                onChange={handleChange}
                placeholder="Enter deal periods"
                required
              />
            </div>

            {/* Terms */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📋 Terms</label>
              <textarea
                className="form-control rounded-3 shadow-sm"
                name="terms"
                rows="3"
                value={formData.terms}
                onChange={handleChange}
                placeholder="Enter deal terms"
                required
              ></textarea>
            </div>


            {/* Date */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Deal Date</label>
              <input
                type="date"
                className="form-control"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>

            {/* Remarks */}
            <div className="col-md-6">
              <label className="form-label fw-bold">Remarks</label>
              <textarea
                className="form-control"
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                rows="3"
              />
            </div>

            {/* Submit */}
            <div className="col-12 text-center">
              <button type="submit" className="btn btn-warning px-5">
                💾 Update Deal
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
}

export default EditDeal;
